<template>
    <CCard class="order-price">
        <CCardHeader>
            <strong>Суммы заказа</strong>
        </CCardHeader>
        <CCardBody class="pt-1 pb-1">
            <!-- <CRow>
                <CCol sm="6" />
                <CCol sm="3" align="right">Сумма до скидок</CCol>
                <CCol sm="3" align="right">Сумма</CCol>
            </CRow> -->
            <CRow>
                <CCol sm="6">При создании заказа</CCol>
                <CCol sm="3" align="right" class="order-price__old-price">
                    {{ formatPrice(firstOrderOldPrice) }}
                </CCol>
                <CCol sm="3" align="right">{{ formatPrice(firstOrderPrice) }}</CCol>
            </CRow>
            <CRow>
                <CCol sm="6">Замены</CCol>
                <CCol sm="3" align="right" class="order-price__old-price">-</CCol>
                <CCol sm="3" align="right">{{ formatPrice(itemsReplaceSum) }}</CCol>
            </CRow>
            <CRow>
                <CCol sm="6">Итог с заменами</CCol>
                <CCol sm="3" align="right" class="order-price__old-price">-</CCol>
                <CCol sm="3" align="right">{{ formatPrice(+order.price - +itemsRefundSum) }}</CCol>
            </CRow>
            <CRow>
                <CCol sm="6">Возвраты</CCol>
                <CCol sm="3" align="right" class="order-price__old-price">-</CCol>
                <CCol sm="3" align="right">{{ formatPrice(+itemsRefundSum) }}</CCol>
            </CRow>
            <CRow v-if="adminOnly">
                <CCol sm="6">Доставка</CCol>
                <CCol sm="3" align="right" class="order-price__old-price">-</CCol>
                <CCol sm="3" align="right">{{ formatPrice(order.delivery_price) }}</CCol>
            </CRow>
            <CRow v-if="adminOnly">
                <CCol sm="6">Ожидание</CCol>
                <CCol sm="3" align="right" class="order-price__old-price">-</CCol>
                <CCol sm="3" align="right">{{ formatPrice(order.waiting_price) }}</CCol>
            </CRow>
            <CRow v-if="adminOnly && order.service_fee">
                <CCol sm="6">Сервисный сбор</CCol>
                <CCol sm="3" align="right" class="order-price__old-price">-</CCol>
                <CCol sm="3" align="right">{{ formatPrice(order.service_fee) }}</CCol>
            </CRow>
            <CRow>
                <CCol sm="6" class="order-price__big">Итог</CCol>
                <CCol sm="3" align="right" class="order-price__old-price">
                    {{ (+order.old_price > 0 && +order.old_price != +order.price) ? formatPrice(+order.old_price) : '' }}
                </CCol>
                <CCol sm="3" align="right" class="order-price__big">
                    {{ formatPrice(orderPriceWithDelivery) }}
                </CCol>
            </CRow>
            <CRow>
                <CCol sm="6">Оплачено</CCol>
                <CCol sm="3" align="right" class="order-price__old-price">-</CCol>
                <CCol sm="3" align="right" class="order-price__big" :class="(allPaymentPrice === orderPriceWithDelivery) ? 'order-price__success' : 'order-price__danger'">
                    {{ formatPrice(allPaymentPrice) }}
                </CCol>
            </CRow>
            <CRow>
                <CCol sm="6">{{ ((+orderPriceWithDelivery - +allPaymentPrice) > 0) ? 'Доплата' : 'Возврат' }}</CCol>
                <CCol sm="3" align="right" class="order-price__old-price">-</CCol>
                <CCol sm="3" align="right" :class="(allPaymentPrice === orderPriceWithDelivery) ? 'order-price__success' : 'order-price__danger'">
                    {{ formatPrice(orderPriceWithDelivery - allPaymentPrice) }}
                </CCol>
            </CRow>
            <!-- <CRow>
                <CCol sm="3" />
                <CCol sm="6" align="center">В заказе</CCol>
                <CCol sm="3" align="center">Оплачено</CCol>
            </CRow>
            <CRow>
                <CCol sm="3" class="order-price__big">Итог</CCol>
                <CCol
                    sm="3"
                    align="right"
                    class="order-price__old-price">{{ (order.old_price > 0 && +order.old_price != +order.price) ? formatPrice(order.old_price) : '' }}</CCol>
                <CCol
                    sm="3"
                    align="right"
                    class="order-price__big">{{ formatPrice(order.price) }}</CCol>
                <CCol
                    sm="3"
                    align="right"
                    class="order-price__big"
                    :class="(allPaymentPrice === order.price) ? 'order-price__success' : 'order-price__danger'">{{ formatPrice(allPaymentPrice) }}</CCol>
            </CRow>
            <CRow>
                <CCol sm="3">Возврат/доплата</CCol>
                <CCol sm="3" />
                <CCol sm="3" />
                <CCol sm="3" align="right" :class="(allPaymentPrice === order.price) ? 'order-price__success' : 'order-price__danger'">
                    {{ formatPrice(order.price - allPaymentPrice) }}
                </CCol>
            </CRow>
            <CRow>
                <CCol sm="3" align="right">замены позиций</CCol>
                <CCol sm="3" />
                <CCol sm="3" align="right">{{ formatPrice(itemsReplaceSum) }}</CCol>
                <CCol sm="3" />
            </CRow>
            <CRow>
                <CCol sm="3" align="right">возвраты позиций</CCol>
                <CCol sm="3" />
                <CCol sm="3" align="right">{{ formatPrice(itemsRefundSum) }}</CCol>
                <CCol sm="3" />
            </CRow>
            <CRow>
                <CCol sm="3">При создании заказа</CCol>
                <CCol
                    sm="3"
                    align="right"
                    class="order-price__old-price">{{ (firstOrderOldPrice > 0 && firstOrderOldPrice != firstOrderPrice) ? formatPrice(firstOrderOldPrice) : '' }}</CCol>
                <CCol sm="3" align="right">{{ formatPrice(firstOrderPrice) }}</CCol>
                <CCol sm="3" align="right">{{ formatPrice(firstPaymentPrice) }}</CCol>
            </CRow> -->
            <CRow v-if="adminOnly">
                <CCol sm="12" align="right">
                    <CButton v-if="needSurcharge" color="primary" @click="paymentConfirm">Корректировка</CButton>
                    <CButton v-else-if="canRefund" color="primary" @click="modalRefund.visible = true">Возврат</CButton>
                    <CButton v-else color="primary" @click="paymentConfirm">Корректировка</CButton>
                </CCol>
            </CRow>
            <CRow v-if="order.promotion_id && (+order.old_price !== +order.price)">
                <CCol sm="3"><b>Акция</b></CCol>
                <CCol sm="3">Сумма скидки</CCol>
                <CCol sm="3">За счет Партнера</CCol>
                <CCol sm="3">За счет МИРСИТИ</CCol>
            </CRow>
            <CRow v-if="order.promotion_id && (+order.old_price !== +order.price)">
                <CCol sm="3">
                    <CLink :to="{ path: `${order.promotion && order.promotion.common ? `/promotions/${order.promotion.id}` : getPromotionLink()}` }">
                        {{ getPromotionDiscount() }}
                    </CLink>
                </CCol>
                <CCol sm="3">{{ getPromotionDiscountSum() }}</CCol>
                <CCol sm="3">{{ +order.promotion.entity_discount_percent }}%</CCol>
                <CCol sm="3">{{ +order.promotion.discount - +order.promotion.entity_discount_percent }}%</CCol>
            </CRow>

            <template v-if="order.rd && order.rd.items && (+order.old_price !== +order.price)">
                <CRow v-if="!order.promotion_id && dishPromotionTable">
                    <CCol sm="3"><b>Акции</b></CCol>
                    <CCol sm="3">Сумма скидки: {{ getPromotionDiscountSumForDish() }}</CCol>
                </CRow>
                <template v-for="item in order.rd.items">
                    <CRow
                        v-if="item.enabled && item.promotion_id !== null"
                        :key="item.promotion_id"
                        class="dish">
                        <CLink :to="{path: `/promotions/${item.promotion_id}` }"> {{ getPromotionDiscountDish(item.promotion_id) }} на блюдо: {{ item.dish_title }} </CLink>
                    </CRow>
                </template>
            </template>
            
            <CRow v-if="order.promocode_id">
                <CCol sm="3"><b>Промокод</b></CCol>
                <CCol sm="3">Сумма скидки</CCol>
                <CCol sm="3">За счет Партнера</CCol>
                <CCol sm="3">За счет МИРСИТИ</CCol>
            </CRow>
            <CRow v-if="order.promocode_id">
                <CCol sm="3">
                    <CLink :to="{ path: `/promocodes/${order.promocode_id}` }">{{ getDiscount() }}</CLink>
                </CCol>
                <CCol sm="3">
                    {{
                        order.promocode_details && order.promocode_details.discount_sum
                            ? order.promocode_details.discount_sum
                            : getPromotionDiscountSum()
                    }}
                </CCol>
                <CCol sm="3">
                    {{
                        order.promocode_details && order.promocode_details.discount_sum
                            ? order.promocode.entity_discount_sum ? `${order.promocode.entity_discount_sum}р.` : ''
                            : order.promocode.entity_discount_percent ? `${order.promocode.entity_discount_percent}%` : ''
                    }}
                </CCol>
                <CCol sm="3">
                    {{
                        order.promocode_details && order.promocode_details.discount_sum
                            ? order.promocode.discount_sum ? `${+order.promocode.discount_sum - +order.promocode.entity_discount_sum}р.` : ''
                            : order.promocode.discount_percent ? `${+order.promocode.discount_percent - +order.promocode.entity_discount_percent}%` : ''
                    }}
                </CCol>
            </CRow>
        </CCardBody>
        <OrderRefund
            :modal="modalRefund"
            :refund="orderPriceWithDelivery < allPaymentPrice ? Math.abs(orderPriceWithDelivery - allPaymentPrice).toFixed(2) : 0"
            @refund="orderRefund"
            @cancel="modalRefund.visible = false" />
    </CCard>
</template>

<script>
    import Vue from 'vue';
    import { ORDER_PAYMENT_STATUS, ORDER_TYPE } from '../../utils/order';
    import OrderRefund from './OrderRefund';

    export default {
        name: 'OrderPrice',

        components: {
            OrderRefund
        },

        props: {
            id: {
                type: Number,
                default: null
            },
            order: {
                type: Object,
                default: () => {}
            },
            payments: {
                type: Array,
                default: () => []
            },
            items: {
                type: Array,
                default: () => []
            },
        },

        data() {
            return {
                isAuthorized: false,
                dishPromotionTable: false,
                modalRefund: {
                    visible: false,
                },
                adminOnly: false,
                promotions: [],
            };
        },

        computed: {
            firstPaymentPrice() {
                const payment = this.payments[0];
                return payment ? payment.price : 0;
            },
            successPaymentPrice() {
                const payment = this.payments.filter(payment => {
                    return payment.status === ORDER_PAYMENT_STATUS.SUCCESS && !payment.tips;
                })[0];
                return payment ? payment.price : 0;
            },
            allPaymentPrice() {
                return this.payments.reduce((sum, payment) => {
                    return sum + (payment.status === ORDER_PAYMENT_STATUS.SUCCESS && !payment.tips ? +payment.price : 0);
                }, 0);
            },
            firstOrderPrice() {
                const disabled = this.items.filter(item => {
                    return !item.enabled;
                });
                if(disabled.length) {
                    return this.items.reduce((sum, item) => {
                        return item.enabled ? sum : sum + (+item.price * +item.quantity);
                    }, 0) - (this.order.promocode_details?.discount_sum ? +this.order.promocode_details.discount_sum : 0);
                }
                return this.items.reduce((sum, item) => {
                    return sum + (+item.price * +item.quantity);
                }, 0) - (this.order.promocode_details?.discount_sum ? +this.order.promocode_details.discount_sum : 0);
            },
            firstOrderOldPrice() {
                const disabled = this.items.filter(item => {
                    return !item.enabled;
                });

                if(disabled.length) {
                    return this.items.reduce((sum, item) => {
                        let oldPrice = item.dish && item.promotion_id ? +item.old_dish_price : +item.old_price;
                        return item.enabled ? sum : sum + (+oldPrice * +item.quantity);
                    }, 0);
                }
                
                return this.items.reduce((sum, item) => {
                    let oldPrice;
                    
                    if (item.dish && item.promotion_id) {
                        const ingredientsSum = (item.ingredients || []).reduce((ingredientSum, ingredient) => {
                            const price = +ingredient.price || 0;
                            const quantity = +ingredient.quantity || 0;
                            return ingredientSum + (price * quantity);
                        }, 0);

                        const modifiersSum = (item.modifiers || []).reduce((modifierSum, modifier) => {
                            const price = +modifier.price || 0;
                            const quantity = +modifier.quantity || 1;
                            return modifierSum + (price * quantity);
                        }, 0);

                        const itemAdditivesSum = ingredientsSum + modifiersSum;
                        oldPrice = +item.old_dish_price + itemAdditivesSum;
                    } else {
                        oldPrice = +item.old_price;
                    }
                    
                    return sum + (oldPrice * +item.quantity);
                }, 0);
            },
            itemsReplaceSum() {
                const enabled = this.items.filter(item => {
                    return item.enabled;
                });
                const disabled = this.items.filter(item => {
                    return !item.enabled;
                });
                if(enabled.length && disabled.length) {
                    const enabledSum = enabled.reduce((sum, item) => {
                        return sum + (+item.price * +item.quantity);
                    }, 0);
                    const disabledSum = disabled.reduce((sum, item) => {
                        return sum + (+item.price * +item.quantity);
                    }, 0);
                    return enabledSum - disabledSum;
                }
                return 0;
            },
            itemsRefundSum() {
                return -1 * this.items.reduce((sum, item) => {
                    return item.enabled ? sum + +item.refund_sum : sum;
                }, 0);
            },
            canRefund() {
                return this.order.payment_confirmed || (new Date().getTime() - new Date(this.order.created_at).getTime() > 24*60*60*1000);
            },
            needSurcharge() {
                return Math.round((+this.orderPriceWithDelivery - +this.allPaymentPrice) * 100) > 0;
            },
            orderPriceWithDelivery() {
                return this.adminOnly ? +this?.order?.price + +this?.order?.delivery_price + +this?.order?.waiting_price + (+this?.order?.service_fee || 0) : this?.order?.price;
            }
        },

        watch: {
            order: {
                deep: true,
                async handler() {
                    this.adminOnly = !JSON.parse(localStorage.getItem('settings')).is_business_admin;
                    if (this?.order?.ed?.items?.length) {
                        const entityId = this?.order?.ed?.items[0]?.entity_id;
                        const entitySettings = await this.axios.get(`/entities/settings/${entityId}`);
                        if (entitySettings?.data?.admin_access) {
                            this.adminOnly = true;
                        }
                    }
                }
            }
        },

        async mounted() {
            try{
                const promotions = await Vue.axios.get('/common-promotions');
                this.promotions = promotions.data;
            }catch(e){
                this.$root.$emit('showError', 'Ошибка загрузки данных.');
            }
        },

        methods: {
            formatPrice(price) {
                return (Math.round(+price * 100) / 100).toFixed(2) + 'p.';
            },
            getDiscount() {
                if (
                    this.order.promocode_details &&
                    this.order.promocode_details.description
                ) {
                    return this.order.promocode_details.description + '';
                }
            },
            getPromotionDiscount() {
                if (
                    this.order.promotion_details &&
                    this.order.promotion_details.description
                ) {
                    return this.order.promotion_details.description;
                }
            },
            getPromotionDiscountDish(item) {
                this.dishPromotionTable = true;
                let promo = [];
                this.promotions.forEach(promotion => {
                    promo.push({
                        value: promotion.id,
                        label: promotion.title,
                        disc: promotion.discount
                    });
                });
                for(let prom of promo){
                    if(item === prom.value){  
                        return `Скидка ${prom.disc}%`
                    }
                }
            },

            getPromotionDiscountSum() {
                const oldPrice = this.getOldPrice();
                const discountSum = this.order.promocode ? +this.order.promocode?.discount_sum : 0;
                // Minus promocode discount sum, cus we need to count it after discount %
                const refoundSum = this._getRefundFor(this.order, 'Партнера') + this._getRefundFor(this.order, 'МИРСИТИ');
                const allDiscountSum = (+this.order?.price && +oldPrice) ? ((+this.order?.price - +oldPrice) * -1) - discountSum - refoundSum : 0;
                return this.formatPrice(allDiscountSum);
            },

            getPromotionDiscountSumForDish() {
                let sum = 0;
                for(let item of this.order.rd.items){
                    if(item.enabled == true){
                        sum += item.price;
                    }
                }
                return +this.order.old_price - sum;
            },
            _getRefundFor (order, name) {
                const orderItems = this.getOrderItemsByType(order)?.items;

                if (!orderItems) {
                    return 0;
                }

                const sum = orderItems.reduce((result, item) => {
                    if (item.refund_for === name) {
                        result += +item.refund_sum || 0;
                        return result;
                    }
                    return result;
                }, 0);
                return sum;
            },
            getOldPrice() {
                if (!this.order?.promocode && !this.order?.promotion) {
                    return this.order.price;
                }

                if (+this.order?.old_price > +this.order?.price) {
                    return this.order.old_price;
                }

                const promotion = this.order?.promotion;
                const promocode = this.order?.promocode;

                const items = this.getOrderItemsByType(this.order)?.items || [];
                let itemsPrice = items.reduce((total, item) => {
                    if (!item.enabled) {
                        return total;
                    }

                    let price = (+item?.old_price && +item?.old_price > +item?.price) ? +item?.old_price : +item?.price;
                    total += price * item?.quantity ? price * item?.quantity : price;

                    return total;
                }, 0);

                let orderOldPrice = 0;

                if (promotion && promocode) {
                    const discountFromPromotion = this._getPriceFromDiscount(this.order.price, promotion?.discount);
                    const discountFromPromocode = this._getPriceFromDiscount(this.order.price, promocode?.discount_percent);
                    const discountSumFromPromocode = +this.order.price - +promocode?.discount_percent;
                    let totalPrice = +this.order.price;

                    if (discountFromPromotion) {
                        totalPrice = discountFromPromotion;
                    }

                    if (discountSumFromPromocode && !discountFromPromocode) {
                        totalPrice += discountSumFromPromocode;
                    }

                    if (!discountSumFromPromocode && discountFromPromocode) {
                        totalPrice = discountFromPromocode;
                    }

                    orderOldPrice = totalPrice;
                }

                if (promotion && +promotion.discount) {
                    orderOldPrice = this._getPriceFromDiscount(this.order.price, promotion.discount);
                }

                if (promocode) {
                    if (+promocode.discount_sum) {
                        orderOldPrice = +this.order.price - promocode.discount_percent;
                    }
                    if (+promocode.discount_percent) {
                        orderOldPrice = this._getPriceFromDiscount(this.order.price, promocode.discount_percent);
                    }
                }

                if (!promotion && !promocode) {
                    if (this.order?.promocode_details?.discount_percent) {
                        orderOldPrice = this._getPriceFromDiscount(this.order.price, this.order?.promocode_details?.discount_percent);
                    }
                }
                orderOldPrice = +this.order.old_price || +this.order.price;

                return itemsPrice > 0 ? itemsPrice : orderOldPrice;
            },
            _getPriceFromDiscount (price, percent) {
                if (!price || !percent) {
                    return 0;
                }
                return (+price / (100 - +percent)) * 100;
            },
            getOrderItemsByType(order) {
                switch (order.type) {
                case ORDER_TYPE.FLOWERS_DELIVERY: return order.fd;
                case ORDER_TYPE.RESTAURANT_DELIVERY: return order.rd;
                case ORDER_TYPE.GROCER_DELIVERY: return order.gd;
                case ORDER_TYPE.LAUNDRY_DELIVERY: return order.ld;
                case ORDER_TYPE.PHARMACY_DELIVERY: return order.pd;
                case ORDER_TYPE.ASSISTANT_HELP: return order.ah;
                case ORDER_TYPE.ENTITY_DELIVERY: return order.ed;
                }
            },
            orderRefund(refund) {
                this.modalRefund.visible = false;
                this.$emit('refund', refund);
            },
            paymentConfirm() {
                this.$emit('paymentConfirm');
            },
            getPromotionLink() {
                let link = '';

                switch (this.order.type) {
                case ORDER_TYPE.RESTAURANT_DELIVERY:
                    link = `/restaurants/${this.order.rd.items[0].restaurant_id}/promotions/${this.order.promotion_id}`;
                    break;
                case ORDER_TYPE.GROCER_DELIVERY:
                    link = `/grocers/${this.order.gd.items[0].grocer_id}/promotions/${this.order.promotion_id}`;
                    break;
                case ORDER_TYPE.PHARMACY_DELIVERY:
                    link = `/pharmacies/${this.order.pd.items[0].pharmacy_id}/promotions/${this.order.promotion_id}`;
                    break;
                case ORDER_TYPE.ASSISTANT_HELP:
                    link = `/assistants/${this.order.ah.items[0].assistant_id}/promotions/${this.order.promotion_id}`;
                    break;
                case ORDER_TYPE.ENTITY_DELIVERY:
                    link = `/entities/${this.order.ed.items[0].entity.entityType.code}/${this.order.ed.items[0].entity_id}/promotions/${this.order.promotion_id}`;
                    break;
                }

                return link;
            },
            getPromotionDishLink(id) {
                return `/promotions/${id}`
            },
        },
    };
</script>

<style lang="scss" scoped>
.order-price {
    .row {
        border: 1px solid #d8dbe0;
        border-bottom: none;

        &:last-child {
            border-bottom: 1px solid #d8dbe0;
        }
        > div {
            padding: 3px 10px;
            border-right: 1px solid #d8dbe0;

            &:last-child {
                border-right: none;
            }
        }
    }

    &__old-price {
        color: #acb2ba;
        // text-decoration: line-through;
    }

    &__big {
        font-size: 120%;
        font-weight: 600;
    }
    &__success {
        color: #2eb85c;
    }
    &__danger {
        color: #e55353;
    }
}
.dish {
    padding: 3px 10px;
}
</style>
